import { useState, useLayoutEffect } from "react";
import LaunchIcon from '@mui/icons-material/Launch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useNavigate } from "react-router-dom";

export default function Club(props) {
  const id = props.id;
  const name = props.name;
  const address = props.address;
  const fee = props.fee
  const link = props.link;
  const club_details = props.club_details;
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();

  const joinClub = () => {
    const attributes = {
      id: id,
      club_name: name,
      address: address,
      phone: props.phone,
      website: link,
      image_url: props.image_url,
      message: props.message
    };

    sessionStorage.setItem('entered_from_assoc_level', JSON.stringify(true));

    navigate(`club/${id}`, {
      state: {
        previous_page: 'club'
      }
    });
  }

  return (
    <div className="club-container row" style={{margin: '10px 0px'}}>
      <div className="info-container">
        <div className="row">
          <div className="title-container">
            <p className="club-title">{name}</p>
            { club_details && <button className="more-info" onClick={() => setShowInfo((prev) => !prev)}>
              more info
              {!showInfo && <ExpandMoreIcon className="expand-icon" />}
              {showInfo && <ExpandLessIcon className="expand-icon" />}
            </button>}
          </div>

          <div className="fee-container">
            <p className="fee-text">Fee:</p>
            <p className="fee-value"> {fee === 'Varies' ? fee : `$${Number(fee).toFixed(2)}/yr`}</p>
          </div>
        </div>

        <div className="row">
          {address && <p className="col is-1-of-2 address">{address}</p>}
          <a href={`https://${link}`} target='_blank' className="col is-2-of-2 link">
            {link}
            {link && <LaunchIcon className="link-icon" />}
          </a>
        </div>

        {showInfo &&
          <div className="row">
            <p className="info-message">{club_details}</p>
          </div>
        }
      </div>

      <div className="btn-container">
        <button className="join-btn" onClick={props.preview ? null : joinClub}>Join</button>
      </div>
    </div>
  )
}

